import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URI;
//console.log("Base URL:", axios.defaults.baseURL);

const requestGenerico = {
    get : (url, config = undefined) => axios.get(url, config),
    post : (url, body, config = undefined) => axios.post(url, body, config),
    put : (url, body, config = undefined) => axios.put(url, body, config),
    delete: (url, config = undefined) => axios.delete(url, config),
    patch: (url, body, config = undefined) => axios.patch(url, body, config)
};

export default requestGenerico;